<script>
import { portal } from "../../auth_config.json";
export default {
  name: "feedback-modal",
  components: {},
  data() {
    return {
      file2: null,
      form: {
        file: null,
        email: "",
        name: "",
        comment: "",
        portal: portal,
        subscribe: 1,
      },
    };
  },
  created() {},
  destroyed() {},
  methods: {
     sendFeedback() {
      this.$refs["sendfeedback"].show();
    },
    userName() {
        return (
          (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
            ? this.$cookies.get("userDetail").data.name
            : null) || this.data
        );
      },
      userEmail() {
        return (
          (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
            ? this.$cookies.get("userDetail").data.email
            : null) || this.data
        );
      },
    cancelModal() {
      this.$refs["sendfeedback"].hide();
    },
    // dismisModal() {
    //   this.$refs["sendmessage"].hide();
    // },
    // doublemodal() {
    //   this.$refs["sendfeedback"].hide();
    //   this.$refs["sendmessage"].show();
    // },
    async onSubmit(event) {
      event.preventDefault();
      const form = new FormData();
      form.append("email", this.form.email);
      form.append("name", this.form.name);
      form.append("comment", this.form.comment);
      form.append("portal", portal);
      form.append("file", this.file);
      form.append("subscribe", 1);
      await this.$http.post(`https://creativebuffer.com/spendid.php`, form);
      this.doublemodal();
      this.form = {
        email: "",
        name: "",
        comment: "",
        portal: portal,
        subscribe: 1,
      };
    },
  },
};
</script>

<style scoped>
.feedback-logo .light-logo {
  max-height: 60px;
}
.user-feedback {
    font-size: 0.8rem !important;
    padding: 0.28rem 0.65rem;
}
</style>

<template>
  <div class="feedbackform text-center d-inline-block">
      <!-- <b-button class="btn-green mx-1" @click="myFeedbackFunction()">
        Beta Tester Feedback
      </b-button> -->
      <!-- <a > -->
        <!-- <b-button href="https://tally.so/r/waXAd2" target="_blank" size="sm" class="btn-green mr-1 mr-lg-2 user-feedback">
            User Feedback
        </b-button> -->
      <!-- </a> -->
      
    <!-- <b-modal
      id="sendmessage"
      size="md"
      ref="sendmessage"
    >
      <div class="d-block text-center">
        <img alt="thumbs-up" src="thumbs-up.png" class="img-fluid" />
      </div>
      <div class="my-4 d-block text-center">
        <h3 class="font-weight-bold">Thanks for Sharing!</h3>
        <h6>
          Your feedback is a gift and critical <br />
          to the evolution of SPENDiD
        </h6>
      </div>
      <div class="my-4 d-block text-center">
        <b-button
          variant="success"
          class="btn-green mx-1"
          @click="dismisModal()"
        >
          Continue
        </b-button>
      </div>
    </b-modal> -->

    <!-- <b-modal id="sendfeedback" size="md" ref="sendfeedback">
      <template #modal-title>
        <div class="d-block text-center bg-light">
          <img alt="logo" src="logov.png" class="light-logo" />
        </div>
      </template>
      <iframe
        :src="`https://survey.survicate.com/f277ae26ca3ee3c2/?p=constantcontact&first_name=${userName}&email=${userEmail}`"
        id="feedbackIframe"
      ></iframe>
    </b-modal> -->
  </div>
</template>
